import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
import CardContainer from "../../_utils/CommonViewAllCard/CardContainer";
import TextWithBank from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import TextWithIcon from "../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";

const TransactionCard = React.memo(
  ({ transaction, onNavigate, categoryMapper }) => {
    const location = useLocation();
    const getStatusColor = (status) => {
      switch (status) {
        case "failed":
          return "var(--failed)";
        case "processed":
          return "var(--settled)";
        case "processing":
        case "created":
          return "var(--queued)";
        default:
          return "var(--text-primary)";
      }
    };

    const formatToCustom = (date) => {
      const optionsDate = { day: "numeric", month: "short", year: "numeric" };
      const optionsTime = { hour: "numeric", minute: "2-digit", hour12: true };

      const datePart = date.toLocaleDateString("en-GB", optionsDate);
      const timePart = date
        .toLocaleTimeString("en-GB", optionsTime)
        .toLowerCase();

      return `${datePart}, ${timePart}`;
    };

    const handleClick = useCallback(
      (e, context) => {
        onNavigate(
          `/beneficiary_transaction_dashboard/bulk_transaction_view_all/bulk_transaction_detail_page/${context?.id}`,
          {
            state: {
              isViewAll:
                location.pathname ===
                "/beneficiary_transaction_dashboard/bulk_transaction_view_all"
                  ? true
                  : false,
            },
          },
        );
      },
      [onNavigate],
    );

    return (
      <CardContainer
        context={transaction}
        isSelected={false}
        isDisabled={false}
        onClickHandler={handleClick}
      >
        <card-body>
          <TextWithIcon
            type={"text"}
            fontWeight={"normal"}
            text={transaction?.file_name}
            subText={"File name"}
            textColor={"var(--text-primary)"}
          />
          <TextWithIcon
            type={"text"}
            fontWeight={"semibold"}
            text={
              transaction?.file_status?.charAt(0)?.toUpperCase() +
              transaction?.file_status?.slice(1)
            }
            subText={"File status"}
            textColor={getStatusColor(transaction?.file_status)}
          />
          <TextWithIcon
            type={"text"}
            fontWeight={"normal"}
            text={transaction?.uploaded_by}
            subText={"Uploaded by"}
            textColor={"var(--text-primary)"}
          />
          <TextWithBank
            type={"text"}
            text={formatToCustom(new Date(transaction?.created_at))}
            subText={"Date and time"}
            src={categoryMapper(transaction.category)}
          />
        </card-body>
      </CardContainer>
    );
  },
);

export default TransactionCard;
